import ScrollModal from "@/components/common/scroll-modal";
import { Button, Heading, Icon } from "@elaniintc/goes-design-system";
import dayjs from "dayjs";
import { useMemo } from "react";

interface Props {
  data: {
    id: string;
    status: "APPROVED" | "DENIED" | "PENDING" | "IN_PROCESS" | "NOT_STARTED";
    flow_id: string;
    created_at: string;
    updated_at: string;
    comments?: {
      id: string;
      text: string;
      created_at: string;
      updated_at: string;
    }[];
  }[];
  onClose: () => void;
}

const statusParse = {
  APPROVED: "Aprobado",
  DENIED: "Denegado",
  PENDING: "Pendiente",
  IN_PROCESS: "En proceso",
  NOT_STARTED: "No iniciado",
};

const FlowResolutionDetail = ({ data, onClose }: Props) => {
  console.log(data);

  const sortedData = useMemo(() => {
    return [...data].sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
    );
  }, [data]);

  return (
    <ScrollModal
      isOpen
      onClose={onClose}
      modalContentClassName="w-[520px] h-[680px] max-w-[520px] max-h-[680px] rounded-xl"
      header={
        <div className="p-6 pb-4">
          <div className="flex items-center justify-between w-full">
            <div className="text-center !text-h2 font-semibold text-heading">
              <Heading variant="h5">Historial de resoluciones</Heading>
            </div>
            <Button
              variant="quiet"
              size="xs"
              onClick={onClose}
              data-testid="close-new-notification-modal-button"
            >
              <Icon type="far" name="times" className="text-sm text-body" />
            </Button>
          </div>
        </div>
      }
      footer={
        <div className="p-6 pt-4 flex justify-end">
          <Button
            onClick={() => {
              onClose();
            }}
            size="lg"
          >
            Cerrar
          </Button>
        </div>
      }
    >
      <div className="p-6 pt-0">
        {sortedData.map((revision) => (
          <div
            key={revision.id}
            className="border border-neutral-silent rounded-lg p-4 mb-4"
          >
            <p className="text-body">
              <span className="font-semibold">Estado:</span>{" "}
              {statusParse[revision.status]}
            </p>
            <p className="text-body">
              <span className="font-semibold">Creado en:</span>{" "}
              {new Date(revision.created_at).toLocaleString()}
            </p>
            <p className="text-body">
              <span className="font-semibold">Actualizado en:</span>{" "}
              {new Date(revision.updated_at).toLocaleString()}
            </p>
            {revision.comments && revision.comments.length > 0 && (
              <div className="mt-2">
                <span className="text-body font-semibold">Comentarios:</span>
                <ul className="pl-10">
                  {revision.comments.map((comment) => (
                    <li
                      key={comment.id}
                      className="text-body text-sm mt-1 list-disc"
                    >
                      {comment.text}{" "}
                      <span className="text-xs text-neutral-muted">
                        (Creado en:{" "}
                        {dayjs(comment.created_at).format("DD/MM/YYYY HH:mm A")}
                        )
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </ScrollModal>
  );
};

export default FlowResolutionDetail;
